import { gql } from '@apollo/client';

import { CARD_CONTAINER_FRAGMENT } from '../fragments/cardContainer';

export const GET_CARD_CONTAINER_QUERY = gql`
  query GetCardContainer($usePreview: Boolean) {
    cardContainer(usePreview: $usePreview) {
      ...CardContainerFields
    }
  }
  ${CARD_CONTAINER_FRAGMENT}
`;
